import React, { useContext, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { UserMessage } from './UserMessage';
import { BotMessage } from './BotMessage';
import { InitialBotInfo } from './InitialBotInfo';
import { ConversationContext } from '../contexts/ConversationContext';

const ConversationHistoryDiv = styled.div`
    width: 100%; flex-grow: 1; overflow-y: auto;
    scrollbar-width: thin; scrollbar-color: #e3e3e3 transparent;
    padding-right: 50px;
    @media (max-width: 991px) {
        padding-right: 30px;
    }
    @media (max-width: 768px) {
        padding-right: 15px;
    }
    .initializing-panel {display: none;}
`

const MessagesDiv = styled.div`
    display: flex; flex-flow: column; padding-left: 80px;
    transition: transform 0.3s ease-out;
    @media (max-width: 768px) {
        padding-left: 0;
    }
`

export const ConversationHistory: React.FC = () => {
    const { conversationState, messages } = useContext(ConversationContext);
    const [nofMessages, setNofMessages] = useState<number>(0);
    const conversationHistoryRef = useRef<HTMLDivElement>(null);
    
    useEffect(() => {
        if (conversationHistoryRef.current && (nofMessages !== messages.length || conversationState !== 'idle')) {
            const ref = conversationHistoryRef.current;
            setTimeout(() => {
                ref.scrollTop = ref.scrollHeight;

            }, 100)
            setNofMessages(messages.length);
        }
    }, [nofMessages, messages, conversationHistoryRef, conversationState]);

    /* TODO Styling:
    - Wär schön, wenn das automatische Nachscrollen smooth wäre
    */
    
    return (
        <ConversationHistoryDiv ref={conversationHistoryRef}>
            <InitialBotInfo />
            <div className="initializing-panel">ki.sg.ch wird gestartet<span className="dots"></span></div>
            <MessagesDiv className="conversation-panel">
                { messages.map(m => {
                    switch (m.role) {
                        case 'user': return <UserMessage key={m.messageId} message={m} />
                        case 'assistant': return <BotMessage key={m.messageId} message={m} />
                    }
                    return null;
                })}
            </MessagesDiv>
        </ConversationHistoryDiv>
    )
}